import {Injectable} from '@angular/core';
import {NavigationExtras, Router} from '@angular/router';
import 'rxjs/add/operator/toPromise';
import {Headers, Http, RequestMethod, Response} from '@angular/http';
import {GlobalFunction} from './global_function';
import {API} from '../../config/api';

function setBasicAuthHeaders(headers: Headers) {
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    headers.append('Authorization', 'Basic TmhQS25oWkh5cGlXSkF5bjpYV0pMYVBHYjM5cnBpamd2NHdWdDZJYnFSd0Q0d2FVa2ZlbGwyYmRxRUhpTHJ6ZXFrazZwdUM5NjhJS0NpRHpF');
    return headers;
}

function refreshTokenAndRetryRequest(
  error: any,
  refreshToken: () => Promise<any>,
  retryRequest: () => Promise<any>
): Promise<any> {
  if (!error || error.status != 401) {
    throw error;
  }
  return refreshToken().then(() => {
    return retryRequest();
  }).catch(() => {
    throw error;
  });
}

let refreshingTokenPromise: Promise<any> = null;
function cleanUpRefreshingTokenPromise() {
    refreshingTokenPromise = null;
}

@Injectable()
export class Global_DB {
    constructor(
        private http: Http,
        private router: Router
    ) {
        this.setHeader();
    }
    dbname: string = '';
    header: Headers;

    getHeader() {
        return this.header;
    }

    getHeaderCsv() {
      let header = new Headers();
      header.set('Accept', 'text/csv');
      header.set('Content-Type', 'text/csv');
      header.set('Authorization', 'Bearer ' +  localStorage.getItem('token'));

      return header;
    }

    resetHeader() {
      let header = new Headers();
      header.set('Accept', 'application/json');
      header.set('Content-Type', 'application/json');
      header.set('Authorization', 'Bearer ' +  localStorage.getItem('token'));
      this.header = header;
    }
    setHeader(header=null) {
        if(header) {
            this.header = header;
            return true;
        }
        header = new Headers();
        if(!localStorage.getItem('token') || localStorage.getItem('token') == null || localStorage.getItem('token') == '') {
            setBasicAuthHeaders(header);
        }
        else {
            header.set('Accept', 'application/json');
            header.set('Content-Type', 'application/json');
            header.set('Authorization', 'Bearer ' +  localStorage.getItem('token'));
        }
        this.header = header;
    }

    refreshToken(): Promise<any> {
        if (!refreshingTokenPromise) {
            let header = new Headers();
            setBasicAuthHeaders(header);
            let data = {
                grant_type: 'refresh_token',
                audience: 'tuf.joyaether.com',
                refresh_token: localStorage.getItem('refresh_token')
            };
            let data_post = GlobalFunction.get_url_param_by_object(data);
            let refreshTokenUrl = API.API_URL_COMMON + 'auth';
            refreshingTokenPromise = this.http.post(refreshTokenUrl, data_post, { headers: header }).toPromise().then((response: Response) => {
                let result = response.json();
                localStorage.setItem('expires_in', result.expires_in);
                localStorage.setItem('refresh_token', result.refresh_token);
                localStorage.setItem('last_time_login', (new Date().getTime()).toString());
                localStorage.setItem('token', result.access_token);
                this.resetHeader();
                return result;
            });
            refreshingTokenPromise.then(cleanUpRefreshingTokenPromise, cleanUpRefreshingTokenPromise);
        }
        return refreshingTokenPromise;
    }

    error(error: Response | any, dataRecall?, method?: RequestMethod): Promise<any> {
        if (error.status == 401) {
          if (!localStorage.getItem('refresh_token')) {
            return this.redirectLoginPage();
          }
          return this.refreshToken().then(() => {
            location.reload();
          }).catch((e: any) => {
            return this.redirectLoginPage();
          });
        } else {
          if(GlobalFunction.contains(error.status,[405])) { // check if not permission or token is expired
            return this.redirectLoginPage();
          }
          if(GlobalFunction.inArray(error.status, [403, 404])) {
            return Promise.resolve(error.message || error);
          }

          return Promise.reject(error.message || error);
        }
    }

    result(res): Promise<any> {
        return Promise.resolve(JSON.parse(res._body));
    }

    setUrl(url) {
        if(localStorage.getItem('token')) {
            url += (url.match(/\?/gi) ? '&' : '?') +'token=' + localStorage.getItem('token');
        }
        return url.replace('{dbname}', this.dbname);
    }
    link(url, data = undefined) {
        if (data && typeof (data) == 'object') {
            url += (url.match(/\?/gi) ? '&' : '?') + GlobalFunction.get_url_param_by_object(data);
        }
        return url;
    }

    async reCallRequest(url, data?, method?: RequestMethod) {
      if (method == RequestMethod.Get) {
        this.get(url, data);
      }
    }

    async get(url, data = undefined) {
        url = this.link(url, data);
        const doRequest = () => this.http.get(url, { headers: this.getHeader() }).toPromise();
        return doRequest().catch((e: any) => {
            return refreshTokenAndRetryRequest(e, () => this.refreshToken(), doRequest);
        }).then((response: Response) => {
            let result = response.json();

            if (result instanceof Array) {
                let range: string | RegExpMatchArray = response.headers.get('Content-Range');

                // Get total from content-range header field if available.
                // Otherwise assume all items are retrieved and use the number of retrieved items as total
                (result as any).range = range;
                (result as any).total = range && (range = range.match(/\/(.*)/)) && +range[1];
            }

            return result;
        }).catch(
          (e: any) => this.error(e, data, RequestMethod.Get)
        );
    }

    async getCsv(url, data = undefined) {
      url = this.link(url, data);
      const doRequest = () => this.http.get(url, { headers: this.getHeaderCsv() }).toPromise();
      return doRequest().catch((e: any) => {
        return refreshTokenAndRetryRequest(e, () => this.refreshToken(), doRequest);
      }).then((response: Response) => {
        return response;
      }).catch(
        (e: any) => this.error(e, data, RequestMethod.Get)
      );
    }

    async post(url, data = {}) {
        // data = GlobalFunction.get_url_param_by_object(data);
        const doRequest = () => this.http.post(url, data, { headers: this.getHeader() }).toPromise();
        return doRequest().catch((e: any) => {
            return refreshTokenAndRetryRequest(e, () => this.refreshToken(), doRequest);
        }).then(this.result).catch((e: any) => {
            return this.error(e);
        });
    }

    async delete(url, data = undefined) {
        if (data && typeof (data) == 'object') {
            url += (url.match(/\?/gi) ? '&' : '?') + GlobalFunction.get_url_param_by_object(data);
        }
        const doRequest = () => this.http.delete(url, { headers: this.getHeader() }).toPromise();
        return doRequest().catch((e: any) => {
            return refreshTokenAndRetryRequest(e, () => this.refreshToken(), doRequest);
        }).then(this.result).catch((e: any) => {
            return this.error(e);
        });
    }

    async put(url, data = {}) {
        const doRequest = () => this.http.put(url, data, { headers: this.getHeader() }).toPromise();
        return doRequest().catch((e: any) => {
            return refreshTokenAndRetryRequest(e, () => this.refreshToken(), doRequest);
        }).then(this.result).catch((e: any) => {
            return this.error(e)
        });
    }

    ///*************************************************************************************************************************************

    async getWithClientCredentialAuth(url, data = undefined) {

      url = this.link(url, data);
      let urlLogin = API.LOGIN;
      let header = new Headers();
      setBasicAuthHeaders(header);

      let data_post: any = {
        grant_type: 'client_credentials',
        audience: 'tuf.joyaether.com',
      };
      data_post = GlobalFunction.get_url_param_by_object(data_post);

      let headerP = new Headers();
      await this.http.post(urlLogin, data_post, { headers: header }).toPromise().catch(this.error).then( rs =>{
        if(JSON.parse(rs._body).access_token){
          console.log(JSON.parse(rs._body).access_token);
          let tokenP = JSON.parse(rs._body).access_token;
          headerP.append('Accept', 'application/json');
          headerP.append('Content-Type', 'application/x-www-form-urlencoded');
          headerP.append('Authorization', 'Bearer ' +  tokenP);
        }
      });

      return this.http.get(url, { headers: headerP }).toPromise().catch(this.error).then(this.result);

    }

    async postWithClientCredentialAuth(url, data = {}) {
      let urlLogin = API.LOGIN;
      let header = new Headers();
      setBasicAuthHeaders(header);

      let data_post: any = {
        grant_type: 'client_credentials',
        audience: 'tuf.joyaether.com',
      };
      data_post = GlobalFunction.get_url_param_by_object(data_post);

      let headerP = new Headers();
      await this.http.post(urlLogin, data_post, { headers: header }).toPromise().catch(this.error).then( rs =>{
        if(JSON.parse(rs._body).access_token){
          console.log(JSON.parse(rs._body).access_token);
          let tokenP = JSON.parse(rs._body).access_token;
          headerP.append('Accept', 'application/json');
          headerP.append('Content-Type', 'application/json');
          headerP.append('Authorization', 'Bearer ' +  tokenP);
        }
      });

      return this.http.post(url, data, { headers: headerP }).toPromise().catch(this.error).then(this.result);
    }

    async putWithClientCredentialAuth(url, data = {}) {
      let urlLogin = API.LOGIN;
      let header = new Headers();
      setBasicAuthHeaders(header);

      let data_post: any = {
        grant_type: 'client_credentials',
        audience: 'tuf.joyaether.com',
      };
      data_post = GlobalFunction.get_url_param_by_object(data_post);

      let headerP = new Headers();
      await this.http.post(urlLogin, data_post, { headers: header }).toPromise().catch(this.error).then( rs =>{
        if(JSON.parse(rs._body).access_token){
          console.log(JSON.parse(rs._body).access_token);
          let tokenP = JSON.parse(rs._body).access_token;
          headerP.append('Accept', 'application/json');
          headerP.append('Content-Type', 'application/json');
          headerP.append('Authorization', 'Bearer ' +  tokenP);
        }
      });

      return this.http.put(url, data, { headers: headerP }).toPromise().catch(this.error).then(this.result);
    }

    redirectLoginPage() {
        return this.revokeToken().then(() => {
            let navigationExtras: NavigationExtras = {
                queryParams: {
                    urlb: window.location.href
                }
            };
            return this.router.navigate(['/authenticate'], navigationExtras);
        });
    }

    revokeToken(): Promise<any> {
        let token = localStorage.getItem('token');
        let postBody = GlobalFunction.get_url_param_by_object({
            token: token
        });

        let cleanUp = () => {
            GlobalFunction.clearAuthenInfo();
            this.setHeader();
        };
        let headers = new Headers();
        setBasicAuthHeaders(headers);

        // Always clear the login state since we do not care
        // whether the server is really revoked the token.
        return this.http.post(API.LOGOUT, postBody, {
            headers: headers
        }).toPromise().then(cleanUp, cleanUp);
    }

}



// WEBPACK FOOTER //
// ./src/app/common/core/global_db.ts